module.exports = __webpack_public_path__ + "media/images/icons/tick-blue-eb610f94f416d0dd64d7468a996923e5.svg";